import { render, staticRenderFns } from "./StaffRenamePreferences.vue?vue&type=template&id=117698b6&scoped=true&"
import script from "./StaffRenamePreferences.vue?vue&type=script&lang=js&"
export * from "./StaffRenamePreferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117698b6",
  null
  
)

export default component.exports